import { render, staticRenderFns } from "./AreaHeader.vue?vue&type=template&id=2ad74960&"
import script from "./AreaHeader.vue?vue&type=script&lang=js&"
export * from "./AreaHeader.vue?vue&type=script&lang=js&"
import style0 from "./AreaHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports